var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEditSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.54952 11.5965H3V9.04697L9.87104 2.17593C9.98372 2.06328 10.1365 2 10.2959 2C10.4552 2 10.608 2.06328 10.7207 2.17593L12.4206 3.87581C12.5332 3.98849 12.5965 4.1413 12.5965 4.30063C12.5965 4.45996 12.5332 4.61277 12.4206 4.72545L5.54952 11.5965ZM3 12.7982H13.8158V14H3V12.7982Z",
    fill: "#C4C7C9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditSmall);
export default __webpack_public_path__ + "static/media/icon-edit-small.02224aa72144aea6ec6548a25326841c.svg";
export { ForwardRef as ReactComponent };